import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { ShoppingBag, Menu, X, Search } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV = [
  { label: "Shop", to: "/shop" },
  { label: "Bundles", to: "/shop?category=creator-bundles" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Support", to: "/support" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-home-logo">
          <div className="w-8 h-8 rounded-full bg-[#0066FF] grid place-items-center text-white font-black text-sm">C</div>
          <span className="font-display font-bold text-lg tracking-tight text-[#1D1D1F]">CreatorMic Pro</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-[#0066FF]" : "text-[#1D1D1F] hover:text-[#0066FF]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/shop" aria-label="Search" data-testid="nav-search" className="hidden md:grid p-2 rounded-full hover:bg-[#F5F5F7] transition-colors">
            <Search size={18} strokeWidth={1.5} className="text-[#1D1D1F]" />
          </Link>
          <button
            onClick={() => setOpen(true)}
            aria-label="Open cart"
            data-testid="nav-cart-btn"
            className="relative p-2 rounded-full hover:bg-[#F5F5F7] transition-colors"
          >
            <ShoppingBag size={20} strokeWidth={1.5} className="text-[#1D1D1F]" />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-0.5 -right-0.5 min-w-5 h-5 px-1 rounded-full bg-[#0066FF] text-white text-[10px] font-bold grid place-items-center"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden p-2 rounded-full hover:bg-[#F5F5F7]"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="nav-mobile-toggle"
          >
            {mobileOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-black/5 bg-white" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setMobileOpen(false)}
                className="py-2 text-base font-medium text-[#1D1D1F]"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </NavLink>
            ))}
            <NavLink to="/track" onClick={() => setMobileOpen(false)} className="py-2 text-base font-medium text-[#1D1D1F]" data-testid="mobile-nav-track">
              Track order
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
}
